import {
  getChatSmoothScrollRaf,
  setChatSmoothScrollRaf,
  cancelChatSmoothScrollRaf
} from './ui-state.js';
import { getEl } from '../../core/dom.js';

function getOwnerChatMessagesEl() {
  return getEl('owner-chat-messages');
}

export function scrollOwnerChatToBottom() {
  const el = getOwnerChatMessagesEl();
  if (!el) return;
  cancelChatSmoothScrollRaf();
  try {
    var prev = el.style.scrollBehavior;
    el.style.scrollBehavior = 'auto';
    el.scrollTop = el.scrollHeight;
    requestAnimationFrame(function () {
      try { el.style.scrollBehavior = prev; } catch (_) {}
    });
  } catch (_) {
    el.scrollTop = el.scrollHeight;
  }
}

export function scrollOwnerChatToBottomSmooth(durMs?: number) {
  const messagesEl = getOwnerChatMessagesEl();
  if (!messagesEl) return;
  const el = messagesEl;
  if (typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    try {
      el.style.scrollBehavior = 'auto';
    } catch (_) {}
    el.scrollTop = el.scrollHeight;
    return;
  }
  try { el.style.scrollBehavior = 'auto'; } catch (_) {}
  if (getChatSmoothScrollRaf()) cancelChatSmoothScrollRaf();
  var start = el.scrollTop;
  var t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
  var dur = typeof durMs === 'number' && durMs > 0 ? durMs : 420;
  var ease = function (t: number) {
    return 1 - Math.pow(1 - t, 3);
  };
  function frame(now: number) {
    var target = Math.max(0, el.scrollHeight - el.clientHeight);
    var u = Math.min(1, (now - t0) / dur);
    el.scrollTop = start + (target - start) * ease(u);
    if (u < 1) {
      setChatSmoothScrollRaf(requestAnimationFrame(frame));
    } else {
      setChatSmoothScrollRaf(null);
      el.scrollTop = Math.max(0, el.scrollHeight - el.clientHeight);
    }
  }
  setChatSmoothScrollRaf(requestAnimationFrame(frame));
}
